import React from 'react';
import {IMetrics} from '../core/models/metrics';
import {metricsEvent} from '../core/classes/api';
import '../styles/rollupbox.scss';

interface IData {
     data: {
          campaign:string;
          type:string;
          backgroundLink: string,
          class: string,
          content: {
               title: string,
               subTitle: string,
               body: string,
               footer: {
                    type: string,
                    subType: string,
                    button: {
                         text: string,
                         link: string,
                         color: string
                    }
               }
          }
     }
}

class RollupBox extends React.Component<IData> {
     element:any = null;
     constructor(props: IData) {
          super(props);
          this.showRollUpBox = this.showRollUpBox.bind(this);
          this.hideRollUpBox = this.hideRollUpBox.bind(this);
          this.metricHandler = this.metricHandler.bind(this);
     }

     componentDidMount() {
          this.element = document.getElementById('rollupbox-wrapper') as HTMLElement;
          setTimeout(this.showRollUpBox, 3000); // Bring up the box after 3 secs that the user hit the page
     }

     /** Display the rollup box */
     showRollUpBox() {
          (this.element.classList.contains('slideOutDown')) ? this.element.classList.replace('slideOutDown', 'slideInUp') : this.element.classList.add('slideInUp');
          setTimeout(this.hideRollUpBox, 15000); // Hide the rollup box after 15 secs in the screen everythime this function is called
     }

     /** Hide the rollup box */
     hideRollUpBox() {
          const event:IMetrics = {
               category: this.props.data.type,
               referer: window.location.href,
               campaign: this.props.data.campaign,
               action: 'dismiss rollupbox'
          }
          metricsEvent(event);
          (this.element.classList.contains('slideInUp')) ? this.element.classList.replace('slideInUp', 'slideOutDown') : this.element.classList.add('slideOutDown');
     }

     public metricHandler(){
          const event:IMetrics = {
               category: this.props.data.type,
               referer: window.location.href,
               campaign: this.props.data.campaign,
               action: 'cta taken'
          }
          metricsEvent(event);
     }

     public render() {

          return (
               <div className="rollupbox-wrapper  animated" id="rollupbox-wrapper" >
                    <div className="rollupbox" style={{ backgroundImage: 'url(' + this.props.data.backgroundLink + ')' }}>
                         <span className="exit-button" onClick={this.hideRollUpBox}><i className="fa fa-times over-image" /></span>
                         <div className="buttons-holder">
                              <a  onClick={this.metricHandler} className={this.props.data.content.footer.button.color + ' rollupbox-btn'} href={this.props.data.content.footer.button.link}>{this.props.data.content.footer.button.text} <i className="fa fa-angle-double-down" /></a>
                              <a href="../" onClick={this.hideRollUpBox}>No, thanks</a>
                         </div>
                    </div>
               </div>
          );
     }
}

export default RollupBox;